import { RefObject, useEffect, useRef } from 'react';

/**
 * Returns a ref that always holds the latest value, synced via useEffect.
 * Useful for accessing the current value inside callbacks or effects
 * without adding the value to their dependency arrays.
 */
export function useLatestRef<T>(value: T): RefObject<T> {
  const ref = useRef(value);

  useEffect(() => {
    ref.current = value;
  }, [value]);

  return ref;
}
